import apiClient from "@/services/apiClient";

/** @typedef {import("@/APIVO/Admin/IAdminEnrolmentActionRequest").IAdminEnrolmentActionRequest} IAdminEnrolmentActionRequest */
/** @typedef {import("@/APIVO/Student/IStudentEnrollment").IStudentEnrollment} IStudentEnrollment */


const client = apiClient;

const getEnrolments = async (endpoint, params) => {
  const response = await client.get(`/AdminEnrolment/${endpoint}`, { params });
  return response.data;
};

export const adminEnrolmentService = {
  getAllEnrolments: (params) => getEnrolments("All", params),
  getPendingEnrolments: () => getEnrolments("Pending"),
  getSubmittedEnrolments: () => getEnrolments("Submitted"),
  getReturnedEnrolments: () => getEnrolments("Returned"),
  getApprovedEnrolments: () => getEnrolments("Approved"),
  getRejectedEnrolments: () => getEnrolments("Rejected"),
  getEnrolmentsByStatus: (status) => getEnrolments(`Status/${status}`),
  getWorkflowHistory: async (studentEnrollmentId) => {
    const response = await client.get(`/AdminEnrolment/GetWorkflowHistory/${studentEnrollmentId}`);
    return response.data;
  },
  getEnrolmentDetail: async (studentBookingId) => {
    const response = await client.get("/AdminEnrolment/Enrollment", { params: { pStudentBookingId: studentBookingId } });
    return response.data;
  },
  viewDocument: (studentEnrollmentId, studentDocId) => client.get(
    `/AdminEnrolment/${studentEnrollmentId}/documents/${studentDocId}/view`,
    { responseType: "blob" },
  ),
  downloadDocument: (studentEnrollmentId, studentDocId) => client.get(
    `/AdminEnrolment/${studentEnrollmentId}/documents/${studentDocId}/download`,
    { responseType: "blob" },
  ),
  /** @param {{ enrollment: IStudentEnrollment, oldEnrollment?: IStudentEnrollment }} values */
  saveStaffCompletion: async ({ enrollment, oldEnrollment }) => {
    const request = { Message: "", Submit: false, Enrollment: enrollment, OldVO: oldEnrollment || enrollment };
    const formData = new FormData();
    formData.append("EnrollmentJson", JSON.stringify(request));
    const response = await client.post("/AdminEnrolment/Save", formData);
    return response.data;
  },
  /** @param {IAdminEnrolmentActionRequest} payload */
  performEnrolmentAction: (payload) => client.post("/AdminEnrolment/Action", payload),
  completeCourseStep: (payload) => client.post("/CourseProgress/AdminCompleteStep", payload),
  updateStatementOfAttainmentNumber: async (studentEnrollmentId, statementOfAttainmentNumber) => {
    const response = await client.put(
      `/AdminEnrolment/${studentEnrollmentId}/statement-of-attainment`,
      { statementOfAttainmentNumber },
    );
    return response.data;
  },
  exportCsvAsqa: async (payload = {}) => {
    const response = await client.post("/AdminEnrolment/exportcsv", payload, {
      responseType: "blob",
    });

    return response;
  },
};
